(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const openCircleUrl = "https://cdn.shopify.com/s/files/1/0798/5610/7832/files/green-dot.svg?v=1693911937";
    const closedCircleUrl = "https://cdn.shopify.com/s/files/1/0798/5610/7832/files/red-dot.svg?v=1704225725";

    const now = new Date();
    const currentDay = now.toLocaleString('en-us', { weekday: 'long' });
    const currentTime = now.getHours() * 100 + now.getMinutes(); // HHMM format for comparison

    let message = '';
    let imageUrl = closedCircleUrl; // Default to closed

    switch(currentDay) {
        case 'Monday':
          message = 'Morgen zijn wij weer geopend van 08:30 - 17:30';
          break;
        case 'Sunday':
            message = 'Dinsdag zijn wij weer geopend van 08:30 - 17:30';
            break;
        case 'Tuesday':
        case 'Wednesday':
        case 'Thursday':
            if(currentTime >= 830 && currentTime <= 1730) {
                imageUrl = openCircleUrl;
                message = 'Wij zijn nu geopend van 08:30 - 17:30';
            } else if(currentTime < 830) {
                message = 'Vandaag zijn wij geopend van 08:30 tot 17:30';
            } else {
                message = 'Morgen zijn wij weer geopend van 08:30 - 17:30';
            }
            break;
        case 'Friday':
            if(currentTime >= 830 && currentTime <= 1730) {
                imageUrl = openCircleUrl;
                message = 'Wij zijn nu geopend van 08:30 - 17:30';
            } else if(currentTime < 830) {
                message = 'Vandaag zijn wij geopend van 08:30 tot 17:30';
            } else {
                message = 'Morgen zijn wij weer geopend van 09:00 - 16:00';
            }
            break;
        case 'Saturday':
            if(currentTime >= 900 && currentTime <= 1600) {
                imageUrl = openCircleUrl;
                message = 'Wij zijn nu geopend van 09:00 - 16:00';
            } else if(currentTime < 900) {
                message = 'Vandaag zijn wij geopend van 09:00 tot 16:00';
            } else {
                message = 'Dinsdag zijn wij weer geopend van 08:30 - 17:30';
            }
            break;
    }

    document.querySelector('.open-hours').innerHTML = `<img id="openClosedBullet" src="${imageUrl}"> <span>${message}</span>`;

    if (window.location.href.indexOf("https://peeters-tweewielers.nl/pages/contact#contactAppointment") > -1) {
      // If the URL contains the target section, scroll to it
      console.log("test1");
      var contactAppointmentSection = document.getElementById("afspraakInplannen");
      if (contactAppointmentSection) {
        console.log("test2");
        contactAppointmentSection.scrollIntoView();

        // Reapply the scroll if necessary after everything loads
        window.onload = function() {
            setTimeout(function() {
                contactAppointmentSection.scrollIntoView();
            }, 100); // Delay might be necessary to override any jumps
        };
      }
    }
    
  });
})();
